import type { AxiosError } from 'axios';
import { ErrorCode, type AppError } from '@models/errors/app-error.model';

const HTTP_UNAUTHORIZED = 401;
const HTTP_FORBIDDEN = 403;
const HTTP_NOT_FOUND = 404;
const HTTP_UNPROCESSABLE = 422;
const HTTP_SERVER_ERROR_MIN = 500;

const resolveErrorCode = (status?: number): ErrorCode => {
  if (!status) return ErrorCode.NETWORK_ERROR;
  if (status === HTTP_UNAUTHORIZED) return ErrorCode.UNAUTHORIZED;
  if (status === HTTP_FORBIDDEN) return ErrorCode.FORBIDDEN;
  if (status === HTTP_NOT_FOUND) return ErrorCode.NOT_FOUND;
  if (status === HTTP_UNPROCESSABLE) return ErrorCode.VALIDATION_ERROR;
  if (status >= HTTP_SERVER_ERROR_MIN) return ErrorCode.SERVER_ERROR;
  return ErrorCode.UNKNOWN_ERROR;
};

export const normalizeApiError = (error: AxiosError): AppError => {
  const status = error.response?.status;
  const responseData = error.response?.data as Record<string, unknown> | undefined;

  return {
    code: resolveErrorCode(status),
    message: (responseData?.message as string | undefined) ?? error.message,
    status,
    correlationId: error.config?.headers?.['X-Correlation-ID'] as string | undefined,
    details: responseData,
    timestamp: new Date().toISOString(),
    isFatal: false,
  };
};
